'use client';

import { SheetTrigger } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';
import { Icon } from '@/shared-ui/atoms/icon';
import { BurgerMenuIcon } from '@/shared-ui/icons';
import { Nav } from '@/shared-ui/organisms/nav';
import type { RefObject } from 'react';
import { SubmenuPanel, type SubmenuPanelItem } from '../../molecules/submenu-panel';
import { Button } from '@/components/ui/button';
import { Link } from '@/shared-ui/atoms';

export type MegaMenuNavItem = {
    id: string;
    label: string;
    to: string;
    link?: boolean;
};

type NavContentProps = {
    items: MegaMenuNavItem[];
    activeDesktopItem?: string;
    setActiveDesktopItem: (itemId: string) => void;
    closeSubmenuPanel: () => void;
    submenuPanels: SubmenuPanelItem[];
    shopAllLabel: string;
    ignorePanelCloseRefs?: Array<RefObject<HTMLElement | null>>;
};

export const NavContent = ({
    items,
    activeDesktopItem,
    setActiveDesktopItem,
    closeSubmenuPanel,
    submenuPanels,
    shopAllLabel,
    ignorePanelCloseRefs,
}: NavContentProps) => {
    return (
        <Nav.Root className="relative w-full">
            <Nav.Content>
                <Nav.Item>
                    <SheetTrigger asChild>
                        <Button
                            aria-label="Open Menu"
                            variant="ghost"
                            className={cn(
                                'text-snk-black gap-2 !p-0 h-auto cursor-pointer font-light text-base hover:bg-snk-primary hover:font-normal'
                            )}>
                            <Icon
                                icon={BurgerMenuIcon}
                                className="text-snk-black md:text-snk-white size-8 md:size-6"
                                decorative
                            />
                            <span className="hidden md:block md:text-snk-white hover:opacity-90 hover:bg-snk-primary">
                                {shopAllLabel}
                            </span>
                        </Button>
                    </SheetTrigger>
                </Nav.Item>

                {items.map((item) => (
                    <Nav.Item key={item.id} desktopOnly>
                        {item.link === false ? (
                            <button
                                type="button"
                                onClick={() => setActiveDesktopItem(item.id)}
                                className="inline-flex items-center justify-center cursor-pointer text-snk-white">
                                {item.label}
                            </button>
                        ) : (
                            <Link
                                to={item.to}
                                onClick={closeSubmenuPanel}
                                className="inline-flex items-center justify-center text-snk-white">
                                {item.label}
                            </Link>
                        )}
                    </Nav.Item>
                ))}
            </Nav.Content>

            <SubmenuPanel
                activeItemKey={activeDesktopItem}
                panels={submenuPanels}
                onClose={closeSubmenuPanel}
                ignoreRefs={ignorePanelCloseRefs}
            />
        </Nav.Root>
    );
};
